<template>
  <table-agency-contract
    v-bind="$attrs"
    :type="$options.TYPE"
    :edit-data="vEditData"
    :fetch-fn="_fetchData"
    :fetch-filters="fetchFilters"
    :right-edit="$options.RIGHT_EDIT"
    :right-delete="$options.RIGHT_DELETE"
    :right-sign="$options.RIGHT_SIGN"
  >
    <template
      v-for="(slot, k) in $slots"
      #[k]
    >
      <slot :name="k" />
    </template>
    <template
      v-for="(slot, k) in $scopedSlots"
      #[k]="props"
    >
      <slot
        v-bind="props"
        :name="k"
      />
    </template>
  </table-agency-contract>
</template>

<script>
import TableAgencyContract from 'components/Table/TableAgencyContract'
import { CONTRACT_TYPES_CUSTOMER } from '@/consts/data/contract'
import { fetchAgencyCustomerContracts } from '@/utils/api/agency/agencyContractsCustomer'
import {
  ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_CUSTOMER,
  ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_CUSTOMER,
  ACCOUNT_RIGHT_SIGN_CREATE_AGENCY_CONTRACT_CUSTOMER
} from '@/consts/rights'

export default {
  name: 'TableAgencyContractCustomer',
  components: { TableAgencyContract },
  TYPE: CONTRACT_TYPES_CUSTOMER,
  RIGHT_EDIT: ACCOUNT_RIGHT_EDIT_AGENCY_CONTRACT_CUSTOMER,
  RIGHT_DELETE: ACCOUNT_RIGHT_DELETE_AGENCY_CONTRACT_CUSTOMER,
  RIGHT_SIGN: ACCOUNT_RIGHT_SIGN_CREATE_AGENCY_CONTRACT_CUSTOMER,
  props: {
    customer: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    fetchFilters () {
      if (this.customer) {
        return {
          customers: [this.customer.slug]
        }
      }
      return {}
    },
    vEditData () {
      if (this.customer) {
        return {
          customer: this.customer
        }
      }
      return {}
    }
  },
  methods: {
    _fetchData: fetchAgencyCustomerContracts
  }
}
</script>

<style scoped>

</style>
